import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://static.readdy.ai/image/97c793d11ca453c3d5eaa5489729c4a4/3bfb866afc0eced546632b7a30a6b70d.png" 
              alt="通訊行 Logo" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              服務項目
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              產品與配件
            </button>
            <button
              onClick={() => scrollToSection('plans')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              門號方案
            </button>
            <button
              onClick={() => scrollToSection('consultation')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              線上諮詢
            </button>
            <button
              onClick={() => scrollToSection('comparison')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              方案比對
            </button>
            <button
              onClick={() => scrollToSection('order')}
              className="bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              快速下單
            </button>
          </div>

          <button
            className="lg:hidden text-gray-700 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('features')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              服務項目
            </button>
            <button onClick={() => scrollToSection('products')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              產品與配件
            </button>
            <button onClick={() => scrollToSection('plans')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              門號方案
            </button>
            <button onClick={() => scrollToSection('consultation')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              線上諮詢
            </button>
            <button onClick={() => scrollToSection('comparison')} className="block w-full text-left text-gray-700 hover:text-teal-600 py-2 cursor-pointer">
              方案比對
            </button>
            <button onClick={() => scrollToSection('order')} className="block w-full text-center bg-teal-600 text-white px-6 py-2.5 rounded-full hover:bg-teal-700 cursor-pointer">
              快速下單
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
